import { combineReducers } from "redux";
import auth from "../auth/store/reducers";
import examReducer from "./online-exam/exam.reducer";
import examReportReducer from "./online-exam/report/report.reducer";
import themeReducer from "./theme/theme.reducer";
import schoolInfoReducer from "./schoolInfo/schoolInfo.reducer";
import assignmentReducer from "./assignment/assignment.reducer";
import assignmentReportReducer from "./assignment/report/report.reducer";

const rootReducer = combineReducers({
  auth,
  theme: themeReducer,
  examReport: examReportReducer,
  exam: examReducer,
  schoolInfo: schoolInfoReducer,
  assignment: assignmentReducer,
  assignmentReport: assignmentReportReducer,
});

export default rootReducer;
